<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <div class="pagination-container-total">共{{ total }}条</div>
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'prev, pager, next'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="scss">
.pagination-container {
  background: #fff;
  padding: 15px 20px;
  background: #f7f7f7;
  border-radius: 2px;
  display: flex;
  .pagination-container-total{
    flex: 1;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 21px;
    letter-spacing: 0.63px;
    display: flex;
    align-items: center;
  }
  .el-pager li{
    height: 30px;
  }

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    margin: 0 7px;
    color: #333333;
    background-color: #f2f2f3;
    border-radius: 3px;
    width: 8px;
    font-family: Avenir, Avenir-Medium;
    font-weight: 500;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #5079F1;
  }

  .el-pagination button, .el-pagination span:not([class*=suffix]){
    height: 30px;
  }
}
.pagination-container.hidden {
  display: none;
}
</style>
